import { Flex } from '@chakra-ui/react';
import { memo } from 'react';

// This component loads before the theme so we cannot use theme tokens here

const Loading = () => {
  return (
    <Flex position="absolute" alignItems="center" justifyContent="center" inset={0} zIndex={99999}>
      Loading~
    </Flex>
  );
};

export default memo(Loading);
